<template>
  <div v-if="!owner.isUseRowButtons">
    <template v-for="(button) in owner.defaultRowButtons">
      <template v-if="isDesign">
        <DsfButton v-if="showDefaultButtons(button.id)"
                   :key="button.id"
                   btn-style="icon-text" 
                   :icon="button.icon"
                   :title="button.title"
                   style="min-width: auto"></DsfButton>
      </template>
      <template v-else>
        <DsfButton v-if="showDefaultButtons(button.id)"
                   :class="[button.id+'-button-'+scope.row.$hash]"
                   :key="button.id"
                   btn-style="icon-text"
                   :icon="button.icon"
                   :title="button.title"
                   style="min-width: auto"
                   @click="button.handler(scope)"></DsfButton>
      </template>
    </template>
  </div>
  <div v-else>
    <template v-if="isDesign">
      <DsfButtonBar 
        size="small"
        :max-number="owner.rowButtonsMaxNumber" 
        :more-button-text="owner.rowButtonsMoreText"
        :more-button-style="owner.rowButtonsMoreStyle"
        :buttons="owner.rowButtons"
        :emit-prefix="'row-button'"
        :local="scope.row"
        class="ds-no-padding operate-column"
        align="center"></DsfButtonBar>
    </template>
    <template v-else>
      <DsfButtonBar 
        size="small"
        :render-button="renderRowButton"
        :max-number="owner.rowButtonsMaxNumber"
        :more-button-text="owner.rowButtonsMoreText"
        :more-button-style="owner.rowButtonsMoreStyle"
        :buttons="scope.row.$buttons"
        :emit-prefix="'row-button'"
        :local="scope.row" 
        :slot-scope-data="scope"
        class="ds-no-padding operate-column"
        align="center"></DsfButtonBar>
    </template>
  </div>
</template>
<script>
export default {
  name: "DsfSubTableButtons",
  data() {
    return {};
  },
  props: {
    isDesign: {
      type: Boolean,
      default: false
    },
    owner: {
      type: Object,
      default() {
        return null;
      }
    },
    scope: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {},
  updated() {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    showDefaultButtons(id) {
      if (this.isDesign) {
        if (id == "edit") {
          return this.owner.allowEdit && !this.owner.foreverEditor;
        } else {
          return true;
        }
      } else {
        if (id == "edit") {
          return this.owner.allowEdit && !this.owner.foreverEditor && this.owner.renderRowButton(id, this.scope.row) !== false;
        } else {
          return this.owner.renderRowButton(id, this.scope.row) !== false;
        }
      }
    },
    renderRowButton(button, result, data) {
      let result1 = this.owner.renderRowButton(button, data) !== false;
      if (button.actionName == "system_subtable_row_edit") {
        if (result1) {
          result1 = this.owner.allowEdit && !this.owner.foreverEditor;
        }
      }
      return result1;
    }
  }
};
</script>